import { Scope } from '../../api'
import { List, ListItem, ListItemText } from 'cs-kevlar-react'
import * as React from 'react'
import { getScopeLabel } from 'utils'

interface ScopesListProps {
  scopes: Scope[]
  sort?: boolean
}

export const ScopesList: React.FunctionComponent<ScopesListProps> = (props) => {
  const labels = props.scopes.map(getScopeLabel)
  if (props.sort) labels.sort()

  // filter these out since users can't request them
  const filteredLabels = labels.filter(
    (label) =>
      ![
        getScopeLabel(Scope.QueryDocuments),
        getScopeLabel(Scope.ExecuteGrainApi),
      ].includes(label),
  )
  return (
    <List dense disablePadding>
      {filteredLabels.map((label, idx) => (
        <ListItem key={`SCOPE::${idx}`}>
          <ListItemText primary={label} />
        </ListItem>
      ))}
    </List>
  )
}
